import FilterForm from 'components/forms/FilterForm';
import { CrudFilters, HttpError, useShow } from '@refinedev/core';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { Form, Input, Space, Table, Tabs, Tag } from 'antd';
import { IAgent } from 'interfaces/agents';
import { IRole } from 'interfaces/roles';
import { PageHeader } from 'components/professor_area/PageHeader';
import { Permissions } from './components/permissions';
import { SettingOutlined } from '@ant-design/icons';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { useParams } from 'react-router-dom';

interface IFilter {
  name: string;
  login: string;
}

export const RolesShow = () => {
  const { queryResult } = useShow<IRole>();
  const { data, isLoading } = queryResult;
  const record = data?.data;
  const { id } = useParams();
  const { tableProps, searchFormProps } = useTable<IAgent, HttpError, IFilter>({
    resource: 'agents',
    pagination: {
      mode: 'server'
    },

    onSearch: params => {
      const filters: CrudFilters = [];
      const { name, login } = params;

      filters.push(
        {
          field: 'filter[by_name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[by_login]',
          operator: 'eq',
          value: login
        }
      );

      return filters;
    },

    filters: {
      permanent: [
        {
          field: 'filter[by_role_id]',
          operator: 'eq',
          value: id
        }
      ]
    }
  });
  const pagination =
    typeof tableProps.pagination === 'object'
      ? tableProps.pagination
      : undefined;
  const totalUsers = pagination?.total ?? tableProps.dataSource?.length ?? 0;

  return (
    <ShowLayout isLoading={isLoading} title="Visualizar perfil">
      <PageHeader
        title={record?.name}
        icon={SettingOutlined}
        meta={
          <Space>
            <Tag>ID: {record?.id}</Tag>
            <Tag>Usuários: {totalUsers}</Tag>
          </Space>
        }
      />

      <Tabs defaultActiveKey="users" className="custom-tabs">
        <Tabs.TabPane tab="Usuários do perfil" key="users">
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item name="name">
              <Input placeholder="Nome" className="lg:min-w-[300px]" />
            </Form.Item>

            <Form.Item name="login">
              <Input placeholder="Login" className="lg:min-w-[300px]" />
            </Form.Item>
          </FilterForm>

          <Table
            {...tableProps}
            rowKey="id"
            pagination={{
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} usuários`
            }}
          >
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="login"
              key="login"
              title="Login"
              render={value => <TextField value={value} />}
            />

            <Table.Column<IAgent>
              title="Ações"
              align="center"
              width={100}
              dataIndex="actions"
              render={(_, record) => {
                return (
                  <EditButton
                    resource="agents"
                    hideText
                    size="small"
                    recordItemId={record.id}
                  />
                );
              }}
            />
          </Table>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Regras de acesso" key="permissions">
          <Permissions permissions={record?.permissions || []} disabled />
        </Tabs.TabPane>
      </Tabs>
    </ShowLayout>
  );
};
